"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _freeze = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/freeze"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var CancellationTokenRegistration = /*#__PURE__*/function () {
  /**
   * Creates an object used to unregister a callback registered to a
   * CancellationToken.
   * @param {function(): void} callback
   * @param {CancellationTokenSource} source
   */
  function CancellationTokenRegistration(callback, source) {
    (0, _classCallCheck2.default)(this, CancellationTokenRegistration);
    this.callback = callback;
    this.source = source;

    if (_freeze.default) {
      (0, _freeze.default)(this);
    }
  }

  (0, _createClass2.default)(CancellationTokenRegistration, [{
    key: "unregister",
    value: function unregister() {
      if (this.source != null) {
        if (this.source.tokenRegistrations != null) {
          var index = this.source.tokenRegistrations.indexOf(this);

          if (index > -1) {
            this.source.tokenRegistrations.splice(index, 1);
          }
        }
      }
    }
  }]);
  return CancellationTokenRegistration;
}();

var _default = CancellationTokenRegistration;
exports.default = _default;